import SubPage from "@/layout/SubPage.vue"
import Base from "@/router/routers/model/base"
import Health from "@/router/routers/model/health"
import Clinic from "@/router/routers/model/clinic"

export default {
  path: "business",
  name: "business",
  component: SubPage,
  meta: { title: "业务", icon: "dashboard" },
  hidden: true,
  children: [{
    path: "manager",
    name: "manager",
    component: SubPage,
    meta: { title: "管理平台", icon: "dashboard" },
    hidden: true,
    children: [
      // --- 基础模块 ---
      { ...Base },
      // --- 健康模块 ---
      { ...Health },
      // --- 门店模块 ---
      { ...Clinic }
    ]
  }]
}
